<template>
  <b-card>
    <usuario-externo-list
      :carregar="carregar"
      class="lista-usuario-externo"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :info="info"
      :filtros="filtros"
      filtrar-por-ativo
    >
      <template
        slot="celula-personalizada"
        slot-scope="{props}"
      >
        <span v-if="props.column.label === 'Empresa'">
          {{ props.row.empresaNome.substring(0, 30) }}
        </span>
      </template>

      <template
        slot="etiquetas-personalizadas"
        slot-scope="{props}"
      >
        <span
          v-if="props.row.notificado || (!props.row.notificado && props.row.dataUltimoAcesso !== '')"
          v-b-tooltip.hover
          :title="props.row.dataUltimoAcesso? 'Acesso confirmado' : 'Aguardando primeiro acesso'"
          :class="['ativo-badge', {'acesso-badge aguardando': !props.row.dataUltimoAcesso, 'acesso-badge confirmado': props.row.dataUltimoAcesso && props.row.dataUltimoAcesso !== ''}]"
        >
          {{ props.row.dataUltimoAcesso ? 'Confirmado' : 'Aguardando' }}
        </span>
      </template>

      <template
        slot="botao-adicional"
        slot-scope="{props}"
      >
        <b-btn
          v-b-tooltip.hover
          title="Enviar convite"
          variant="none"
          :class="['btn-none rounded-pill icone-acao', {'btn-outline-warning': !props.row.dataUltimoAcesso, 'btn-outline-secondary': props.row.dataUltimoAcesso !== ''}]"
          style="margin-right:0.3rem"
          :disabled="!props.row.ativo || props.row.dataUltimoAcesso !== ''"
          @click="enviarNotificacao(props.row)"
        >
          <feather-icon icon="SendIcon" />
        </b-btn>
      </template>

      <template
        slot="corpo-info-adicional"
        slot-scope="{props}"
      >
        <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
        <b-row class="mb-1">
          <b-col
            cols="12"
            style="text-align:center"
          >
            <span>Empresas Vinculadas</span>
          </b-col>
        </b-row>
        <div
          v-for="(empresaVinculada,i) in props.row.empresas"
          :key="i"
        >
          <b-row>
            <b-col cols="12">
              <span
                class="empresa-vinculada"
                @click="acessaEmpresa(empresaVinculada.empresa.id)"
              >{{ `${empresaVinculada.empresa.razaoSocial} - ${empresaVinculada.empresa.cadastroFederal}` }}</span>
            </b-col>
          </b-row>
        </div>
      </template>
    </usuario-externo-list>
  </b-card>
</template>

<style lang="scss">
.acesso-badge {
  font-weight: 500 !important;
  padding: 0.1rem 0.5rem;
  text-align: center;
  border-radius: 0.358rem !important;
  display: inline-block;

  &.confirmado {
    border: 1px solid #28c76f;
    color: #28c76f;
  }

  &.aguardando {
    border: 1px solid #ff9f43;
    color: #ff9f43;
  }
}

.empresa-vinculada:hover{
  text-decoration: underline;
  cursor: pointer;
}

.ativo-badge {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}

.icone-acao {
  padding: 0.4rem;
}

.lista-usuario-externo {
  .th-acao {
    width: 10.5rem !important;
  }
}
</style>

<script>
import api from '@/app-modulo/comuns/usuario-externo/shared/services/api'

export default {
  name: 'UsuarioExternoVisualizacao',
  components: {
    UsuarioExternoList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [
        {
          label: 'Nome', field: 'nome', type: 'personalizada', showActive: true, editable: true,
        },
        { label: 'Empresa', field: 'empresaNome', type: 'personalizada' },
        { label: 'Inscrição', field: 'empresaCadastroFederal' },
        { label: 'Integração com RH', field: 'codigoIntegracao' },
      ],
      filtros: [{ colunas: ['Nome', 'EmpresaNome', 'EmpresaCadastroFederal', 'Login', 'CodigoIntegracao'], valor: null }],
      info: [
        { label: 'Último acesso: ', campo: 'dataUltimoAcesso' },
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
    }
  },
  methods: {
    carregar(page, pageSize, filtros) {
      return api.getUsuariosExternos(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-usuario-externo' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-usuario-externo', params: { id: value.id } })
    },
    remover(itens) {
      const itensInner = itens
      return new Promise(resolve => {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < itensInner.length; i++) {
          const item = itensInner[i]
          api.deleteUsuarioExterno(item.id)
            .then(() => {
              // tenporario
              if (i === itensInner.length - 1) {
                resolve()
              }
            })
            .catch(err => {
              this.$handleError(err)
            })
        }
      })
    },
    acessaEmpresa(id) {
      this.$router.push(`/empresas/editar/${id}`)
    },
    enviarNotificacao(value) {
      api.conviteAcesso(value.id)
        .then(() => {
          this.$set(value, 'notificado', true)
          this.$sucesso('Convite enviado para o email do usuário externo')
        })
        .catch(err => {
          this.$handleError(err)
          throw err
        })
    },
  },
}
</script>
